<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" :data="data" noDataText="Nenhum item encontrado no período selecionado">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <vs-row>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6" vs-xs="12" class="p-0">
            <div class="flex-wrap-reverse items-center flex-1">
              <!-- Datas -->
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
                <div
                  class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-64"
                >
                  <feather-icon icon="CalendarIcon" svgClasses="h-4 "/>
                  <span class="mr-2">{{ dateFilterText }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                </div>

                <vs-dropdown-menu>
                  <vs-dropdown-item @click="setDateFilter(0)">
                    <span> {{$t("Today")}} </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setDateFilter(1)">
                    <span>{{$t("Yesterday")}}</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setDateFilter(2)">
                    <span>{{$t("LastSevenDays")}}</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setDateFilter(3)">
                    <span>{{$t("LastThirtyDays")}}</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setDateFilter(4)">
                    <span>{{$t("LastNinetyDays")}}</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="setDateFilter(5)">
                    <span>{{$t("AllRecords")}}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <!-- Salvar Dados -->
              <MobileSalvarDados :dispositivo="dispositivo" relationship="websearch" :pagination="meta.pagination"/>
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="6" vs-xs="12" class="p-0">
            <vs-input
              icon="icon-search"
              icon-pack="feather"
              class="w-full input-rounded-full no-icon-border mb-4"
              placeholder= "Pesquisar por termo"
              v-model.lazy="searchTerm"
            />
          </vs-col>

          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" vs-xs="12">
            <div class="con-vs-pagination vs-pagination-primary" v-show="meta.pagination.total_pages > 1">
              <vs-pagination :total="meta.pagination.total_pages" v-model="page" :max="5"></vs-pagination>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th sort-key="datetime"> {{$t("DATE")}} </vs-th>
        <vs-th sort-key="keyword"> {{$t("RESEARCHTERM")}} </vs-th>
        <vs-th sort-key="url"> {{$t("LINK")}} </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr v-show="loading">
          <vs-td class="text-nowrap" colspan="3">
            <div id="loading" class="vs-con-loading__container"></div>
          </vs-td>
        </vs-tr>
        <vs-tr :data="search" :key="index" v-for="(search, index) in webSearchList">
          <vs-td class="text-nowrap">
            <span>{{ search.datetime | formatDateTime }}</span>
          </vs-td>
          <vs-td>
            <span>{{ search.keyword }}</span>
          </vs-td>
          <vs-td>
            <span>
              <a
                target="_blank"
                :href="`https://www.google.com/search?q=${search.url}`"
              >{{ `https://www.google.com/search?q=${search.url}` }}</a>
            </span>
          </vs-td>
        </vs-tr>
        <vs-tr v-show="data.length > 0 && !loading && dispositivo.uid && dispositivo.licence.until === null">
          <vs-td class="text-nowrap" colspan="3">
            <div class="w-full">
              <div class="vx-col w-full h-full prc-2">
                <vx-card slot="no-body" class="text-center h-full bg-primary-gradient greet-user">
                  <feather-icon
                    icon="AwardIcon"
                    class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
                    svgClasses="h-8 w-8"
                  ></feather-icon>
                  <h1 class="mb-6 text-white"> {{$t("ImportantWarning")}} </h1>
                  <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
                    {{$t("Lock")}}
                    <strong> {{$t("FreeVersion")}}</strong> {{$t("FreeVersionTwo")}}
                  </p>
                  <br/>
                  <router-link :to="`/planos/mobile/${dispositivo.uid}/1`">
                    <vs-button color="warning" type="relief">
                      <vs-icon icon-pack="fas" icon="fa-shopping-cart"></vs-icon>&nbsp;{{$t("ReleaseFullContent")}}
                    </vs-button>
                  </router-link>
                </vx-card>
              </div>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: [],
      loading: true,
      dispositivo: {
        licence: {
          until: null
        }
      },
      meta: {
        pagination: {
          total_pages: 0
        }
      },
      page: 1,
      dateFilterId: 5,
      dateFilterText: 'Todos os Registros',
      searchTerm: ''
    }
  },

  watch: {
    page: function () {
      this.load()
    }
  },

  computed: {
    webSearchList() {
      if (this.searchTerm) {
        return this.data.filter(item => {
          return this.searchTerm
          .toLowerCase()
          .split(' ')
          .every(v => item.keyword.toLowerCase().includes(v))
        })
      } else {
        return this.data
      }
    }
  },

  mounted() {
    this.load()

    this.$vs.loading({
      container: '#loading',
      type: 'default',
      scale: 1
    })

  },

  methods: {
    handleChangePage: function (page) {
      this.page = page
      this.load()
    },
    load: function () {
      const mobile = JSON.parse(this.$localStorage.get('mobile'))
      this.$api
      .get(
        `/api/v${mobile.panel_version}/mobile/websearch/${mobile.uid}?page=${this.page}&dateFilterId=${this.dateFilterId}`
      )
      .then(response => {
        this.loading = false
        this.data = response.data.data
        this.meta = response.data.meta || {pagination: {total_pages: 0}}
      })

      this.$api
      .get(`/api/v${mobile.panel_version}/mobile/device/${mobile.uid}`)
      .then(response => {
        this.dispositivo = response.data.data
        this.$EventBus.$emit('deviceChanged', this.dispositivo)
      })
    },
    setDateFilter: function (filterId) {
      this.dateFilterId = filterId
      this.load()

      switch (this.dateFilterId) {
        case 0:
          this.dateFilterText = 'Hoje'
          break
        case 1:
          this.dateFilterText = 'Ontem'
          break
        case 2:
          this.dateFilterText = 'Últimos 7 dias'
          break
        case 3:
          this.dateFilterText = 'Últimos 30 dias'
          break
        case 4:
          this.dateFilterText = 'Últimos 90 dias'
          break
        case 5:
          this.dateFilterText = 'Todos os Registros'
          break
      }
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

#loading {
  width: 100px;
  height: 100px;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
